import { useCurrentProjectId } from '@/pages/AdvancedEditor/hooks/useCurrentProjectId';
import useGetProject from '@/pages/AdvancedEditor/hooks/useGetProject';
import { newProjectId } from '@/pages/AdvancedEditor/types';
import { GET_PROJECTS_KEY, useDeleteItemFromLibraryMutation } from '@/state/video-library/videoLibrary';
import { LibraryItemType } from '@d-id/types';
import { StoreType } from 'polotno/model/store';
import { useQueryClient } from 'react-query';

export const useCleanDraft = (store: StoreType) => {
    const { mutateAsync: deleteItem } = useDeleteItemFromLibraryMutation(true);
    const queryClient = useQueryClient();

    const projectId = useCurrentProjectId();

    const { data: project } = useGetProject(projectId);

    const deleteProject = async () => {
        await queryClient.resetQueries(GET_PROJECTS_KEY);
        await deleteItem({ videoId: projectId, type: LibraryItemType.PROJECT });
    };

    const handleDraftRemove = async () => {
        if (projectId === newProjectId) {
            return;
        }

        if (!store?.pages?.length) {
            await deleteProject();
            return;
        }

        const hasAudio = project?.audio_url;

        if (hasAudio) return;

        const canRemove = store.pages.every(page => {
            const noBackground = page.background === 'white';
            const noChildren = page.children.length === 0;
            const noText = !page.custom?.textInput;
            const noAudio = !page.custom?.uploadedAudio?.data;

            return noBackground && noChildren && noText && noAudio;
        });

        if (!canRemove) return;

        await deleteProject();
    };

    return { cleanEmptyDraft: handleDraftRemove };
};
